var exports = {
  "kL": "xa15a2ab7--e3ec3d--container",
  "hE": "xa15a2ab7--e3ec3d--tooltip-trigger",
  "Gq": "xa15a2ab7--e3ec3d--tooltip-content",
};

module.exports = exports;
